import $tool from './tool'

//客户端信息获取
const client = {
    ip: '',
    browser: {
        version: '',
        name: '',
    },
    browseInfo: {
        userAgent: '',
        browser: '',
        version: '',
        os: '',
        equipment: '',
        resolution: '',
        referenceUrl: '',
        referenceTitle: '',
        type: '' //pc、wap
    },
    os: {
        name: '',
    },
    screen: {
        width: window.screen.width,
        height: window.screen.height,
        resolution: window.screen.width + ' * ' + window.screen.height,
    },

    async install(Vue) {
        getBrowseInfo();
        this.ip = await getIp();
        Vue.prototype.$client = client;
    }
};

function getBrowseInfo() {
    let ua, liulanqi, banben, os, equipment, isEdge, isSafari, isChrome, isFirefox, isOpera, isIE, isBrowser,
        isAndroid, isWe, isIPhones, isIPad, isVersion, isWeChat;
    ua = navigator.userAgent;
    liulanqi = '';
    banben = '';
    os = '';
    equipment = '';
    isEdge = ua.match(/(Edge)\/([\d.]+)/i);
    isSafari = ua.match(/Version\/([\d.]+)\s+?(Safari)/i);
    isChrome = ua.match(/(Chrome)\/([\d.]+)/i);
    isFirefox = ua.match(/(Firefox)\/([\d.]+)/i);
    isOpera = ua.match(/(OPR|OPERA).+?([\d.]+)/i);
    isIE = ua.indexOf('Trident') > -1 ||
        ua.toLocaleLowerCase().indexOf('msie') > -1;
    isBrowser = ua.match(/(\w+Browser)[^\d]+?([\d.]+)/i) ||
        ua.match(/\d\s+?([^\d]+)([\d.]+)$/i);
    isAndroid = ua.match(/(Android[\s\d.]+);.+?([^;]+)Build/i);
    isWe = ua.match(/MicroMessenger.+?([\d.]+)/i);
    isIPhones = ua.match(/CPU([\s\w\d_]+)like/i);
    isIPad = ua.match(/iPad/i) ? 'iPad' : 'iPhone';
    isVersion = ua.match(/Version\/([\d.]+)/i);
    isWeChat = isWe;

    //如果是移动端
    if (!!ua.match(/AppleWebKit.*Mobile.*/)) {
        if (isWe) {
            liulanqi = '微信';
            banben = isWe[1];
        } else {
            if (isBrowser) {
                liulanqi = isBrowser[1];
                banben = isBrowser[2];
                if (liulanqi.indexOf('Browser') === -1 && isVersion) {
                    banben = isVersion[1];
                }
            } else {
                liulanqi = '手持设备浏览器';
                banben = '未知';
            }
        }
        if (isAndroid) {
            os = isAndroid[1];
            equipment = isAndroid[2];
        } else {
            if (isIPhones) {
                os = isIPhones[1];
            } else {
                os = isIPad;
            }
            equipment = isIPad;
        }
        client.browseInfo.type = 'wap';
    } else {
        if (isSafari) {
            liulanqi = isSafari[2];
            banben = isSafari[1];
        }
        if (isChrome) {
            liulanqi = isChrome[1];
            banben = isChrome[2];
        }
        if (isFirefox) {
            liulanqi = isFirefox[1];
            banben = isFirefox[2];
        }
        if (isEdge) {
            liulanqi = isEdge[1];
            banben = isEdge[2];
        }
        if (isOpera) {
            liulanqi = 'OPERA';
            banben = isOpera[2];
        }

        if (isIE) {
            liulanqi = 'IE';
            let isIEV01 = ua.match(/(MSIE).+?(\d+)/i);
            let isIEV02 = ua.match(/(rv).+?(\d+)/i);
            if (isIEV01) {
                banben = isIEV01[2];
            }
            if (isIEV02) {
                banben = isIEV02[2];
            }
        }
        os = ua.match(/windows/i) ? 'Windows' : 'Mac OS';
        equipment = '电脑端';
        client.browseInfo.type = 'pc';
    }
    client.browseInfo.userAgent = ua;
    client.browseInfo.browser = liulanqi;
    client.browseInfo.version = banben;
    client.browseInfo.os = os;
    client.browseInfo.equipment = equipment;
    client.browseInfo.resolution = window.screen.width + 'X' + window.screen.height;
    client.browseInfo.referenceUrl = document.referrer || '';
    client.browseInfo.referenceTitle = '';
}

function getIp() {
    if($tool.getLS('dell_host_ip')){
        return new Promise( (resolve,reject) => {
            resolve($tool.getLS('dell_host_ip'));
        })
    }
    const headEle = document.getElementsByTagName('head')[0]
    let script = document.createElement('script');
    script.type = "text/javascript";
    script.src = '//s2-api.smarket.net.cn/cityjson';
    headEle.appendChild(script);
    return new Promise( (resolve,reject) => {
        if(script.readyState){ //IE
            script.onreadystatechange = function () {
                if(script.readyState === "loaded" || script.readyState === 'complete'){
                    script.onreadystatechange = null;
                    headEle.removeChild(script)
                }
            };
        } else {
            script.onload = function () {
                $tool.setLS('dell_host_ip', returnCitySN?.cip)
                resolve(returnCitySN?.cip);
                headEle.removeChild(script)
            };
        }
    })
}
export default client
